import useReduxAction from '@hooks/useReduxAction'
import type { AdCopyModel, OrderItemModel, ServiceModel } from '@models/types'

import type { EntityOptions } from '@redux/modules/module'

export type AdCopyOrderItemModel = OrderItemModel &{
  ad_copies: AdCopyModel[],
  service: ServiceModel,
}

type Options = {
  requestOptions?: EntityOptions,
}

const useImportProjectAdCopies = (campaignId: number, options: Options = {}) => {
  const { data: adCopyOrderItems } = useReduxAction(
    'campaigns',
    'loadPendingAdCopyOrderItems',
    {
      entityId: campaignId,
      ...options.requestOptions,

    },
    [campaignId],
    {
      dispatchAction: (action, requestOptions) => action(campaignId, requestOptions),
      shouldPerformFn: () => !!campaignId,
    },
  )

  return {
    adCopyOrderItems,
    // @ts-expect-error TS2339
    hasAdCopyOrderItems: !!adCopyOrderItems?.length,
  }
}

export default useImportProjectAdCopies
